import { apiGet, apiPut } from "./http";
import type { BenefitCategory, ExclusiveBenefit } from "../pages/admin/utils/benefitsStore";

export interface ExclusiveBenefitDto {
  benefitKey: string;
  name: string;
  icon: string;
  category: string;
  enabled: boolean;
  sortOrder: number;
  description?: string;
}

const CATS: BenefitCategory[] = ["rights", "discount", "activity", "service"];

function normalizeCategory(c: string): BenefitCategory {
  return CATS.includes(c as BenefitCategory) ? (c as BenefitCategory) : "rights";
}

export function dtoToExclusiveBenefit(d: ExclusiveBenefitDto): ExclusiveBenefit {
  return {
    id: d.benefitKey,
    name: d.name,
    icon: d.icon,
    category: normalizeCategory(d.category),
    enabled: d.enabled,
    description: d.description?.trim() ? d.description.trim() : undefined,
  };
}

export function exclusiveBenefitsToReplaceBody(items: ExclusiveBenefit[]) {
  return {
    benefits: items.map((b, i) => ({
      benefitKey: b.id,
      name: b.name,
      icon: b.icon,
      category: b.category,
      enabled: b.enabled !== false,
      sortOrder: i + 1,
      description: b.description?.trim() ?? "",
    })),
  };
}

export async function fetchExclusiveBenefitsForTenant(tenantLegacyId: string): Promise<ExclusiveBenefit[]> {
  const rows = await apiGet<ExclusiveBenefitDto[]>(
    `/api/tenants/${encodeURIComponent(tenantLegacyId)}/exclusive-benefits`,
  );
  return rows.map(dtoToExclusiveBenefit);
}

export async function putExclusiveBenefitsForTenant(
  tenantLegacyId: string,
  items: ExclusiveBenefit[],
): Promise<ExclusiveBenefit[]> {
  const rows = await apiPut<ExclusiveBenefitDto[]>(
    `/api/tenants/${encodeURIComponent(tenantLegacyId)}/exclusive-benefits`,
    exclusiveBenefitsToReplaceBody(items),
  );
  return rows.map(dtoToExclusiveBenefit);
}
